import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-btl-expense-modal',
  templateUrl: './btl-expense-modal.component.html'
})
export class BtlExpenseModalComponent implements OnInit {

  savingFlag: boolean = false;
  formData: any = {};
  billImages: any[] = [];
  imagePreviews: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<BtlExpenseModalComponent>,
    public serve: DatabaseService,
    public toast: ToastrManager
  ) { }

  ngOnInit() { }

  onFileChange(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (this.billImages.length >= 5) {
          this.toast.errorToastr('Maximum 5 bill images allowed');
          break;
        }
        const file = files[i];
        if (!file.type.match('image.*')) {
          this.toast.errorToastr('Please select a valid image file');
          continue;
        }
        if (file.size > 5 * 1024 * 1024) {
          this.toast.errorToastr('Image size should be less than 5MB');
          continue;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.billImages.push(e.target.result);
          this.imagePreviews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
    event.target.value = '';
  }

  removeImage(index: number) {
    this.billImages.splice(index, 1);
    this.imagePreviews.splice(index, 1);
  }

  submitExpense() {
    if (!this.formData.actual_expense) {
      this.toast.errorToastr('Enter actual expense!');
      return;
    }
    if (this.billImages.length < 1) {
      this.toast.errorToastr('Upload minimum 1 bill image');
      return;
    }
    if (!this.formData.remark) {
      this.toast.errorToastr('Remark is mandatory');
      return;
    }

    this.savingFlag = true;

    const payload = {
      event_id: this.data.event_id,
      actual_expense: this.formData.actual_expense,
      billImages: this.billImages,
      remark: this.formData.remark
    };

    this.serve.post_rqst(payload, 'Event/eventExpenseSubmit').subscribe((result) => {
      this.savingFlag = false;
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg']);
        this.dialogRef.close(true);
      } else {
        this.toast.errorToastr(result['statusMsg']);
      }
    }, error => {
      this.savingFlag = false;
      this.toast.errorToastr('Something went wrong, please try again');
    });
  }

  numberOnly(event: any) {
    const pattern = /[0-9.\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) { event.preventDefault(); }
  }
}
